module.exports = __webpack_public_path__ + "img/dot-net-core.0ea25b8b.svg";